import mitt from 'mitt';

export const eventBus = mitt();

export const OPEN_FULLSCREEN_MODAL = 'OPEN_FULLSCREEN_MODAL';
export const CLOSE_FULLSCREEN_MODAL = 'CLOSE_FULLSCREEN_MODAL';

export const GCNET_PREPARE_DETAIL_CHARTS = 'GCNET_PREPARE_DETAIL_CHARTS';
export const GCNET_OPEN_DETAIL_CHARTS = 'GCNET_OPEN_DETAIL_CHARTS';
export const GCNET_INJECT_MICRO_CHARTS = 'GCNET_INJECT_MICRO_CHARTS';

export const OPEN_TEXT_PREVIEW = 'OPEN_TEXT_PREVIEW';
export const OPEN_VIDEO_PREVIEW = 'OPEN_VIDEO_PREVIEW';
export const OPEN_DATA_PREVIEW_IFRAME = 'OPEN_DATA_PREVIEW_IFRAME';
export const SELECT_EDITING_RESOURCE = 'SELECT_EDITING_RESOURCE';
export const CANCEL_EDITING_RESOURCE = 'CANCEL_EDITING_RESOURCE';
export const SAVE_EDITING_RESOURCE = 'SAVE_EDITING_RESOURCE';

export const INJECT_MAP_FULLSCREEN = 'INJECT_MAP_FULLSCREEN';
export const INJECT_GENERIC_COMPONENT = 'INJECT_GENERIC_COMPONENT';

export const MAP_ZOOM_IN = 'MAP_ZOOM_IN';
export const MAP_ZOOM_OUT = 'MAP_ZOOM_OUT';
export const MAP_ZOOM_CENTER = 'MAP_ZOOM_CENTER';
export const MAP_COMPARE_START = 'MAP_COMPARE_START';
export const MAP_COMPARE_END = 'MAP_COMPARE_END';
export const MAP_TOGGLE_BASE_LAYER = 'MAP_TOGGLE_BASE_LAYER';
export const MAP_GEOMETRY_MODIFIED = 'MAP_GEOMETRY_MODIFIED';

export const EDITMETADATA_OBJECT_UPDATE = 'EDITMETADATA_OBJECT_UPDATE';
export const EDITMETADATA_NEXT_MAJOR_STEP = 'EDITMETADATA_NEXT_MAJOR_STEP';
export const EDITMETADATA_CUSTOMFIELDS = 'EDITMETADATA_CUSTOMFIELDS';
export const EDITMETADATA_CUSTOMFIELDS_ENTRY = 'EDITMETADATA_CUSTOMFIELDS_ENTRY';

export const EDITMETADATA_MAIN = 'EDITMETADATA_MAIN';
export const EDITMETADATA_MAIN_DESCRIPTION = 'EDITMETADATA_MAIN_DESCRIPTION';
export const EDITMETADATA_MAIN_HEADER = 'EDITMETADATA_MAIN_HEADER';
export const EDITMETADATA_PUBLICATION_INFO = 'EDITMETADATA_PUBLICATION_INFO';
export const EDITMETADATA_REVIEW_INFO = 'EDITMETADATA_REVIEW_INFO';
export const EDITMETADATA_FUNDING_INFO = 'EDITMETADATA_FUNDING_INFO';

export const EDITMETADATA_DATA = 'EDITMETADATA_DATA';
export const EDITMETADATA_DATA_RESOURCE = 'EDITMETADATA_DATA_RESOURCE';
export const EDITMETADATA_DATA_RESTRICTED = 'EDITMETADATA_DATA_RESTRICTED';
export const EDITMETADATA_DATA_RESOURCE_SIZE = 'EDITMETADATA_DATA_RESOURCE_SIZE';
export const EDITMETADATA_DATA_RESOURCES = 'EDITMETADATA_DATA_RESOURCES';
export const EDITMETADATA_DATA_INFO = 'EDITMETADATA_DATA_INFO';
export const EDITMETADATA_DATA_LICENSE = 'EDITMETADATA_DATA_LICENSE';
export const EDITMETADATA_DATA_INFO_DATES = 'EDITMETADATA_DATA_INFO_DATES';

export const EDITMETADATA_DATA_GEO = 'EDITMETADATA_DATA_GEO';
export const EDITMETADATA_DATA_GEO_SPATIAL = 'EDITMETADATA_DATA_GEO_SPATIAL';
export const EDITMETADATA_DATA_GEO_MAP_ERROR = 'EDITMETADATA_DATA_GEO_MAP_ERROR';

export const EDITMETADATA_GENERIC_TEXTAREA_PREVIEW_LAYOUT = 'EDITMETADATA_GENERIC_TEXTAREA_PREVIEW_LAYOUT';
export const EDITMETADATA_GENERIC_PLACEHOLDER = 'EDITMETADATA_GENERIC_PLACEHOLDER';
export const EDITMETADATA_RELATED_PUBLICATIONS = 'EDITMETADATA_RELATED_PUBLICATIONS';
export const EDITMETADATA_RELATED_DATASETS = 'EDITMETADATA_RELATED_DATASETS';
export const EDITMETADATA_ORGANIZATION = 'EDITMETADATA_ORGANIZATION';
export const EDITMETADATA_KEYWORDS = 'EDITMETADATA_KEYWORDS';

export const EDITMETADATA_AUTHOR = 'EDITMETADATA_AUTHOR';
export const EDITMETADATA_AUTHOR_LIST = 'EDITMETADATA_AUTHOR_LIST';
export const EDITMETADATA_AUTHOR_DATACREDIT = 'EDITMETADATA_AUTHOR_DATACREDIT';
export const SELECT_EDITING_AUTHOR = 'SELECT_EDITING_AUTHOR';
export const CANCEL_EDITING_AUTHOR = 'CANCEL_EDITING_AUTHOR';
export const SAVE_EDITING_AUTHOR = 'SAVE_EDITING_AUTHOR';
export const REMOVE_EDITING_AUTHOR = 'REMOVE_EDITING_AUTHOR';

export const SELECT_EDITING_DATASET = 'SELECT_EDITING_DATASET';

export const METADATA_EDITING_FINISH_CLICK = 'METADATA_EDITING_FINISH_CLICK';

export const EDITMETADATA_NETWORK_ERROR = 'EDITMETADATA_NETWORK_ERROR';

export const EDITMETADATA_CLEAR_PREVIEW = 'EDITMETADATA_CLEAR_PREVIEW';

export const EDIT_USER_PROFILE = 'EDIT_USER_PROFILE';
export const EDIT_USER_PROFILE_EVENT = 'EDIT_USER_PROFILE_EVENT';
export const USER_PROFILE = 'USER_PROFILE';

export const SHOW_DIALOG = 'SHOW_DIALOG';
export const SHOW_REDIRECT_SIGNIN_DIALOG = 'SHOW_REDIRECT_SIGNIN_DIALOG';
export const SHOW_REDIRECT_DASHBOARD_DIALOG = 'SHOW_REDIRECT_DASHBOARD_DIALOG';

export const AUTHOR_SEARCH_CLICK = 'AUTHOR_SEARCH_CLICK';

export const UPLOAD_STATE_RESET = 'UPLOAD_STATE_RESET';
export const UPLOAD_STATE_RESOURCE_CREATED = 'UPLOAD_STATE_RESOURCE_CREATED';
export const UPLOAD_STATE_UPLOAD_STARTED = 'UPLOAD_STATE_UPLOAD_STARTED';
export const UPLOAD_STATE_UPLOAD_PROGRESS = 'UPLOAD_STATE_UPLOAD_PROGRESS';
export const UPLOAD_STATE_UPLOAD_COMPLETED = 'UPLOAD_STATE_UPLOAD_COMPLETED';
export const UPLOAD_STATE_RESOURCE_UPDATED = 'UPLOAD_STATE_RESOURCE_UPDATED';
export const UPLOAD_ERROR = 'UPLOAD_ERROR';

export const USER_OBJECT = 'USER_OBJECT';

export const EDITMETADATA_PUBLICATION_STATE = 'EDITMETADATA_PUBLICATION_STATE';

export const METADATA_MAIN_HEADER = 'METADATA_MAIN_HEADER';
